import { render } from "./PollFeed.vue?vue&type=template&id=2cef2954"
import script from "./PollFeed.vue?vue&type=script&lang=js"
export * from "./PollFeed.vue?vue&type=script&lang=js"

import "./PollFeed.vue?vue&type=style&index=0&id=2cef2954&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__